import { useMessageStore } from './message-store';
import { LaravelErrorItem } from '../shared/shared-types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useMessage() {
  const messageStore = useMessageStore();

  const clearMessages = () => {
    messageStore.setMessages(null, null, null);
  };

  const setSuccessMessage = (message: string) => {
    messageStore.setMessages(message);
  };

  const setErrors = (
    message: string,
    items: LaravelErrorItem[] | null = null
  ) => {
    messageStore.setMessages(null, message, items);
  };

  const getErrorItem = (key: string): string | null => {
    const errorItems = messageStore.messages.errorItems;
    return errorItems !== null && key in errorItems ? errorItems[key] : null;
  };

  const getErrorMessage = () => {
    return messageStore.messages.error;
  };

  return {
    clearMessages,
    setSuccessMessage,
    setErrors,
    getErrorItem,
    getErrorMessage,
  };
}
